import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ma-2"
}
const _hoisted_2 = {
  class: "text-left",
  style: {"width":"100px"}
}
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = {
  class: "text-left",
  style: {"width":"100px"}
}
const _hoisted_5 = {
  class: "text-left",
  style: {"width":"180px"}
}
const _hoisted_6 = { class: "content-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_progress_record_edit_dialog = _resolveComponent("progress-record-edit-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: 'Child Development', href: '/child-development', color: 'primary' },
          { title: `Class`, href: _ctx.childClassId ? `/child-development/class/${_ctx.year}/${_ctx.childClassId}` : undefined, color: 'primary', disabled: !_ctx.childClassId },
          { title: `${_ctx.childName} (${_ctx.year} ${_ctx.$t('childDevelopment.fiscalYear')})` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `${_ctx.$t('childDevelopment.progressRecord.title')} - ${_ctx.childName} (${_ctx.year != null ? _ctx.year : ''} ${_ctx.$t('common.schoolYear')})`
    }, null, 8, ["value"]),
    _createVNode(_component_v_alert, {
      class: "my-4",
      type: "info",
      color: "primary",
      variant: "outlined",
      density: "compact",
      style: {"font-size":"0.9rem"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.instructions.title')), 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" • " + _toDisplayString(_ctx.$t('childDevelopment.progressRecord.instructions.interest')), 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" • " + _toDisplayString(_ctx.$t('childDevelopment.progressRecord.instructions.growth')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" • " + _toDisplayString(_ctx.$t('childDevelopment.progressRecord.instructions.play')), 1),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" • " + _toDisplayString(_ctx.$t('childDevelopment.progressRecord.instructions.perspective')), 1),
        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
      ]),
      _: 1
    }),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.month')), 1),
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.content')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.edit')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.updatedDate')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressRecords, (record) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: record.month
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.getMonthLabel(record.month)), 1),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(record.content || '-'), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_btn, {
                        small: "",
                        variant: "flat",
                        color: "primary",
                        onClick: ($event: any) => (_ctx.openEditDialog(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.progressRecord.edit')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(record.updatedAt)), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_progress_record_edit_dialog, {
      "is-open": _ctx.isDialogOpen,
      month: _ctx.editingMonth,
      content: _ctx.editingContent,
      "is-saving": _ctx.isSaving,
      onIsOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDialogOpen = $event)),
      onSave: _ctx.saveProgressRecord
    }, null, 8, ["is-open", "month", "content", "is-saving", "onSave"])
  ]))
}